import React from 'react'
import { BrowserRouter,NavLink, Route, Routes } from 'react-router-dom';
import './App.css';
import Park from './components/park/scRNA';
const Home = () => <h1>Human Kidney Single Cell Transcriptome</h1>;
function App() {
  return (
	  Park()
  );
}
export default App;
